export let hres6nuColumns = () => {
  let indexColumns = [
    {
      key: 'codempid',
      name: '',
      labelCodapp: 'HRES6NUC1',
      labelIndex: '30',
      class: 'align-center',
      style: 'min-width: 100px;'
    }, {
      key: 'desc_codempid',
      name: '',
      labelCodapp: 'HRES6NUC1',
      labelIndex: '40',
      style: 'min-width: 200px;'
    }, {
      key: 'dtereq',
      name: '',
      labelCodapp: 'HRES6NUC1',
      labelIndex: '70',
      class: 'align-center',
      style: 'min-width: 120px;',
      dataType: 'date'
    }, {
      key: 'desc_codleave',
      name: '',
      labelCodapp: 'HRES6NUC1',
      labelIndex: '90',
      style: 'min-width: 150px;'
    }, {
      key: 'dteperiod',
      name: '',
      labelCodapp: 'HRES6NUC1',
      labelIndex: '100',
      class: 'align-center',
      style: 'min-width: 200px;',
      dataType: 'dateRange'
    }, {
      key: 'status',
      name: '',
      labelCodapp: 'HRES6NUC1',
      labelIndex: '110',
      style: 'min-width: 200px;'
    }, {
      key: 'desc_codappr',
      name: '',
      labelCodapp: 'HRES6NUC1',
      labelIndex: '120',
      style: 'min-width: 200px;'
    }, {
      key: 'dteappr',
      name: '',
      labelCodapp: 'HRES6NUC1',
      labelIndex: '130',
      class: 'align-center',
      style: 'min-width: 120px;',
      dataType: 'date'
    }, {
      key: 'remark',
      name: '',
      labelCodapp: 'HRES6NUC1',
      labelIndex: '140',
      style: 'min-width: 200px;'
    }, {
      key: 'desc_codempap',
      name: '',
      labelCodapp: 'HRES6NUC1',
      labelIndex: '150',
      style: 'min-width: 200px;'
    }
  ]

  return {
    en: {
      index: indexColumns
    },
    th: {
      index: indexColumns
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/columns/hres6nu.js